module.exports = __webpack_public_path__ + "src/img/select.411ea6e3.svg";